<div class="loading-bar">
    <div class="loading-bar--item"></div>
    <div class="loading-bar--item"></div>
    <div class="loading-bar--item"></div>
    <div class="loading-bar--item"></div>
</div>